import * as React from "react";
import { BooleanInput as Input } from "kanopi-components/BooleanInput";
import { FormControl } from "kanopi-components/Input";
import { WidthContainer } from "../../ChatFlow/WidthContainer";

export function BooleanInput({
  label,
  title,
  help,
  showLabel,
  error,
  onBlur,
  ...props
}: unknown) {
  return (
    <WidthContainer>
      <FormControl
        label={label}
        caption={help}
        title={title}
        hideLabel={!showLabel}
        error={error}
      >
        <Input onBlur={onBlur} {...props} />
      </FormControl>
    </WidthContainer>
  );
}
